/**
 * ============================================================================
 * Purchase 模块 - 枚举定义
 * ============================================================================
 * 
 * 📋 文件职责：
 * - 定义采购模块相关的所有枚举类型
 * - 包含：SupplierType, QualityLevel, OrderStatus, Priority 等
 * 
 * 📖 对应后端：
 * - Model: backend/app/Modules/Purchase/Models/Supplier.php (常量定义)
 * - Model: backend/app/Modules/Purchase/Models/PurchaseOrder.php (常量定义)
 * 
 * ⚠️ 注意事项：
 * - 枚举值必须与后端完全一致
 * - 每个枚举值必须添加中文注释
 * - 使用 TypeScript enum 而不是 type
 * 
 * @module types/purchase/enums
 * @generated Manual (AI-assisted)
 * @last-updated 2025-11-03
 * ============================================================================
 */

/**
 * 供应商类型枚举
 * 
 * 对应后端: Supplier::TYPE_*
 */
export enum SupplierType {
  /** 原材料 */
  RAW_MATERIAL = 1,
  
  /** 半成品 */
  SEMI_FINISHED = 2,
  
  /** MRO */
  MRO = 3,
  
  /** 服务 */
  SERVICE = 4,

  /** 委外加工 */
  OUTSOURCE = 5,
}

/**
 * 企业类型枚举
 * 
 * 对应后端: Supplier::COMPANY_*
 */
export enum CompanyType {
  /** 国企 */
  STATE_OWNED = 1,
  
  /** 民企 */
  PRIVATE = 2,
  
  /** 外企 */
  FOREIGN = 3,
  
  /** 个体 */
  INDIVIDUAL = 4,
}

/**
 * 质量等级枚举
 * 
 * 对应后端: Supplier::QUALITY_*
 */
export enum QualityLevel {
  /** A级 */
  A = 1,
  
  /** B级 */
  B = 2,
  
  /** C级 */
  C = 3,
  
  /** D级 */
  D = 4,
}

/**
 * 采购订单状态枚举
 * 
 * 对应后端: PurchaseOrder::STATUS_*
 */
export enum PurchaseOrderStatus {
  /** 待审核 */
  PENDING = 1,
  
  /** 已确认 */
  CONFIRMED = 2,
  
  /** 部分到货 */
  PARTIALLY_RECEIVED = 3,
  
  /** 全部到货 */
  FULLY_RECEIVED = 4,
  
  /** 已关闭 */
  CLOSED = 5,
  
  /** 已取消 */
  CANCELLED = 6,
}

/**
 * 优先级枚举
 * 
 * 对应后端: PurchaseOrder::PRIORITY_*
 */
export enum Priority {
  /** 紧急 */
  URGENT = 1,
  
  /** 高 */
  HIGH = 2,
  
  /** 中 */
  MEDIUM = 3,
  
  /** 低 */
  LOW = 4,
}

/**
 * 订单来源类型枚举
 * 
 * 对应后端: PurchaseOrder::SOURCE_*
 */
export enum OrderSourceType {
  /** 手工创建 */
  MANUAL = 1,
  
  /** MRP生成 */
  MRP = 2,
  
  /** 需求建议 */
  SUGGESTION = 3,
}

/**
 * 质检状态枚举
 * 
 * 对应后端: PurchaseReceiving::QUALITY_*
 */
export enum QualityStatus {
  /** 待检 */
  PENDING = 1,
  
  /** 合格 */
  QUALIFIED = 2,
  
  /** 不合格 */
  REJECTED = 3,
}

/**
 * 供应商状态枚举
 * 
 * 对应后端: Supplier::STATUS_*
 */
export enum SupplierStatus {
  /** 启用 */
  ACTIVE = 1,
  
  /** 停用 */
  INACTIVE = 0,
}

/**
 * 采购退货类型枚举
 * 
 * 对应后端: PurchaseReturn::TYPE_*
 */
export enum PurchaseReturnType {
  /** 质量问题 */
  QUALITY_ISSUE = 'QUALITY_ISSUE',
  
  /** 发错货 */
  WRONG_DELIVERY = 'WRONG_DELIVERY',
  
  /** 多发货 */
  OVER_DELIVERY = 'OVER_DELIVERY',
  
  /** 运输损坏 */
  DAMAGED = 'DAMAGED',
  
  /** 其他 */
  OTHER = 'OTHER',
}

/**
 * 采购退货来源类型枚举
 * 
 * 对应后端: PurchaseReturn::SOURCE_*
 */
export enum PurchaseReturnSourceType {
  /** NCR不合格品处理 */
  NCR = 'NCR',
  
  /** IQC检验不合格 */
  IQC = 'IQC',
  
  /** 手工创建 */
  MANUAL = 'MANUAL',
}

/**
 * 采购退货状态枚举
 * 
 * 对应后端: PurchaseReturn::STATUS_*
 */
export enum PurchaseReturnStatus {
  /** 草稿 */
  DRAFT = 1,
  
  /** 待审批 */
  PENDING = 2,
  
  /** 已审批 */
  APPROVED = 3,
  
  /** 退货中 */
  SHIPPING = 4,
  
  /** 已完成 */
  COMPLETED = 5,
  
  /** 已驳回 */
  REJECTED = 6,
  
  /** 已取消 */
  CANCELLED = 7,
}
